export const RANGE_SELECTOR = '[data-range-filter]'

const FIELD = '[data-range-field]'

export function writeRange(scope, value) {
  const field = scope.querySelector(FIELD)
  const slider = scope.querySelector('[data-range-slider]')
  const readout = scope.querySelector('[data-range-readout]')
  if (!field || !slider || !readout) return

  field.value = value
  slider.value = value === '' ? slider.dataset.rangeDefault : value
  readout.textContent = value === '' ? readout.dataset.rangeAny : value
}

export function writeRangeFrom(element, value) {
  const scope = element.closest(RANGE_SELECTOR)
  if (scope) writeRange(scope, value)
}

export function clearRanges(scope) {
  scope
    .querySelectorAll(RANGE_SELECTOR)
    .forEach((range) => writeRange(range, ''))
}

// Closing without applying has to put the slider back to what the server rendered.
export function revertRanges(scope) {
  scope.querySelectorAll(RANGE_SELECTOR).forEach((range) => {
    const field = range.querySelector(FIELD)
    if (field) writeRange(range, field.defaultValue)
  })
}

export function appliedRanges(scope) {
  return Array.from(scope.querySelectorAll(FIELD)).filter(
    (field) => field.value !== '',
  )
}
